// Utility function to preload images
export const preloadImages = (imageUrls) => {
  if (!imageUrls || !imageUrls.length) return;
  
  imageUrls.forEach(src => {
    const img = new Image();
    img.src = src;
  });
};

// Function to extract all image URLs from variants
export const getAllImageUrlsFromVariants = (variants) => {
  if (!variants) return [];
  
  return variants.reduce((acc, variant) => {
    if (variant.more_info?.images?.length) {
      return [...acc, ...variant.more_info.images];
    }
    return acc;
  }, []);
};
